<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaMarkdownPreview',
})
</script>
<template>
	<div class="markdown-preview">
		<MdCatalog :editor-id="previewId" :on-click="handleCatalogClick" class="markdown-catalog" />
		<MdPreview :id="previewId" :model-value="content" :on-click="handleCatalogClick" class="markdown-content" />
	</div>
</template>

<script lang="ts" setup name="MaMarkdownPreview">
import { ref, onMounted } from 'vue'
import { MdPreview, MdCatalog } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'

const props = defineProps({
	content: {
		type: String,
		default: ''
	},
	showCatalog: {
		type: Boolean,
		default: true
	}
})
const mdPreview = ref()
const previewId = `md-preview-${Math.random().toString(36).substr(2, 9)}`
const scrollElement = ref<HTMLElement | null>(null)

// 处理目录点击事件
const handleCatalogClick = (event: Event, element: any) => {
	console.log(event.target, element)
	const target = event.target as HTMLElement
	let targetElement = null
	// 阻止默认行为
	event.preventDefault()

	const indicator = document.querySelector('.md-editor-catalog-indicator')
	const catalogContainer = document.querySelector('.markdown-catalog')

	// 为当前点击的目录项添加active类名
	if (target && element) {
		// 移除所有目录项的active类名
		const catalogLinks = document.querySelectorAll('.md-editor-catalog-link')
		catalogLinks.forEach(link => link.classList.remove('md-editor-catalog-active'))
		const targetRect = target.getBoundingClientRect()
		const containerRect = catalogContainer?.getBoundingClientRect() ?? new DOMRect()
		const catalogContainerTop = catalogContainer?.scrollTop
		const relativeTop = targetRect.top - containerRect.top + catalogContainerTop
		console.log(catalogContainer?.scrollTop, targetRect, containerRect, 'tttttt')
		if (indicator) {
			indicator.style.top = relativeTop + 'px'
		}
		target.parentElement?.classList.add('md-editor-catalog-active')
	}

	if (!element) {
		if (target?.getAttribute('href')) {
			targetElement = document.getElementById(target.innerText)
		}
	} else {
		targetElement = document.getElementById(element.text)
	}

	// 查找目标元素
	if (!targetElement) {
		return
	}
	// 平滑滚动到目标位置
	if (scrollElement.value) {
		// 计算目标位置
		const containerRect = scrollElement.value.getBoundingClientRect()
		const targetRect = targetElement.getBoundingClientRect()
		const scrollTop = scrollElement.value.scrollTop
		const targetPosition = scrollTop + targetRect.top - containerRect.top - 20 // 20px 偏移量

		// 平滑滚动
		scrollElement.value.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		})
	} else {
		// 如果没有找到滚动容器，使用默认滚动
		targetElement.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		})
	}
}

onMounted(() => {
	const findScrollContainer = () => {
		// 首先查找最近的带有滚动的父元素
		let parent = document.getElementById(previewId)?.parentElement
		while (parent && parent !== document.body) {
			const computedStyle = window.getComputedStyle(parent)
			const overflow = computedStyle.overflow
			const overflowY = computedStyle.overflowY

			// 检查是否有滚动条
			if (
				(overflow === 'auto' || overflow === 'scroll' || overflowY === 'auto' || overflowY === 'scroll') &&
				parent.scrollHeight > parent.clientHeight
			) {
				console.log('找到滚动容器:', parent)
				return parent
			}
			parent = parent.parentElement
		}

		// 如果没有找到合适的滚动容器，检查 body 和 documentElement
		if (document.body.scrollHeight > document.body.clientHeight) {
			console.log('使用 body 作为滚动容器')
			return document.body
		}

		console.log('使用 documentElement 作为滚动容器')
		return document.documentElement
	}

	// 延迟查找滚动容器，确保DOM完全渲染
	setTimeout(() => {
		scrollElement.value = findScrollContainer()
	}, 100)
})
</script>

<style scoped lang="scss">
.markdown-preview {
	display: flex;
	gap: 16px;
	align-items: flex-start;

	.markdown-catalog {
		flex-shrink: 0;
		width: 240px;
		position: sticky;
		top: 20px;
		max-height: calc(80vh - 20px);
		overflow-y: auto;
		padding: 16px;
		border: 1px solid #e1e4e8;
		border-radius: 8px;
		background: #fafbfc;

		:deep(.md-editor-catalog) {
			padding: 0;
			border: none;
			background: transparent;
		}

		:deep(.md-editor-catalog-link) {
			padding: 4px 8px;
			border-radius: 4px;
			transition: all 0.2s;
			font-size: 13px;
			color: #586069;

			&:hover {
				background: #e1e4e8;
				color: #0366d6;
			}

			&.active {
				background: #0366d6;
				color: white;
				font-weight: 500;
			}
		}
	}

	.markdown-content {
		flex: 1;
		min-width: 0;

		:deep(.md-editor-preview) {
			padding: 0;
			background: transparent;
			border: none;
		}

		:deep(.md-editor-preview-wrapper) {
			font-size: 14px;
			line-height: 1.6;
			color: #333;
		}
	}
}

// 当目录隐藏时，内容占满全宽
.markdown-preview:not(:has(.markdown-catalog)) .markdown-content {
	width: 100%;
}

// 响应式设计
@media (max-width: 768px) {
	.markdown-preview {
		flex-direction: column;

		.markdown-catalog {
			width: 100%;
			position: static;
			max-height: 200px;
			order: -1;
		}
	}
}
</style>
